/* eslint-disable no-undef */
import cdnConfig from '../../../config/cdn';

export const IDENTITY_KEY_NAME = {
  UID: 'id',
  TOKEN: 'token',
  APP_VERSION: 'appVersion',
  APP_NAME: 'appName',
  DEVICE_TYPE: 'deviceType',
};

const prefix = '';
export const STORAGE_KEY = {
  STUDENT_ID: `${prefix}student_id`,
  TOKEN: `${prefix}token`,
  APP_VERSION: `${prefix}app_version`,
  APP_NAME: `${prefix}app_name`,
  DEVICE_TYPE: `${prefix}device_type`,
  PAGES: 'library_book_pages',
};

export const DEVICE = {
  MOBILE: 'mobile',
  PAD: 'pad',
  PC: 'pc',
  ANDROID: 'android',
  IOS: 'iOS',
  OTHER: 'other',
};

export const STAGE_THEME = {
  PRERISE: 'prerise',
  K: 'k',
  S1: 's1',
  S2: 's2',
  S3: 's3',
  S4: 's4',
  S5: 's5',
  TRIAL: 'trial',
  PREK: 'prek',
};

const cdnUrl = cdnConfig[PROCESS_ENV || 'DEV'];

export const LIBRARY_XML_ORIGIN_URL = '/libsrc/';
// export const LIBRARY_ASSETS_ORIGIN_URL = `${window.location.protocol}${cdnUrl}/`;
export const LIBRARY_ASSETS_ORIGIN_URL = `${cdnUrl}/`;
// console.log('LIBRARY_ASSETS_ORIGIN_URL', LIBRARY_ASSETS_ORIGIN_URL);
// export const LIBRARY_ASSETS_ORIGIN_URL =
// `${window.location.protocol}//storage.risecenter.com/prod/`;
export const LIBRARY_ASSETS_LOCAL_URL = 'https://library.mobile/'; // 下载原生的书，音效等需要调用的url，一直不变
